'use client'

import { AuthShell } from '@/components/auth/auth-shell'
import { useProductBrand } from '@/providers/product-brand-provider'
import { CONNECT_BRAND } from '@/lib/connect/brand'

export function AuthEntryShell({ children }: { children: React.ReactNode }) {
  const connect = useProductBrand().product === 'toolfare'
  return (
    <AuthShell
      topAnchored
      showcase={connect ? {
        title: CONNECT_BRAND.name,
        description: CONNECT_BRAND.tagline,
        imageUrl: null,
      } : undefined}
    >
      {children}
    </AuthShell>
  )
}
